"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var SecondPlace = function () {
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.secondPlaceContainer },
        react_1.default.createElement("svg", { width: "33", height: "40", viewBox: "0 0 33 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginBottom: '-35px' } },
            react_1.default.createElement("path", { d: "M0.886719 14.6479H20.3801V10.6534H0.886719V0.00123456H32.417V25.3533H12.8704V29.3479H32.3638V40H0.886719V14.6479Z" }))));
};
exports.default = SecondPlace;
